import { TolerancePeriod } from "../enums/tolerance";

export const ToleranceMaxRange = {
    [TolerancePeriod.DAYS]: 30,
    [TolerancePeriod.MONTHS]: 12,
    [TolerancePeriod.YEARS]: 15,
};
